export default "__VITE_ASSET__82937122__"